import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Unauthorized() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/", { replace: true });
    }, 100);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="p-4 text-center text-red-500">
      {/* <h1>403 - You are not authorized to view this page.</h1>
      <p>Redirecting...</p> */}
    </div>
  );
}